import * as React from 'react';
import { DropdownMenu } from 'ui';
import { SelectItem } from 'ui/common/select/types';
import { MdArrowDropDown } from 'react-icons/md';
import { DropdownItem, DropdownMenuItem } from 'ui/common/dropdown-menu/dropdown-menu-item';
import styles from './dropdown-field.scss';
import type { JSX } from "react";
interface DropdownFieldComponentProps {
  title?: string;
  selectedItem: DropdownItem;
  options: DropdownItem[];
  className?: string;
}

export const mapToMenuItem = (item: SelectItem, onClick?: () => void): DropdownItem => {
  return {
    value: String(item.value),
    description: item.description,
    originalItem: item,
    onClick: onClick
  };
};

class DropdownFieldComponent extends React.Component<DropdownFieldComponentProps, {}> {

  public render(): JSX.Element {
    const {
      title,
      selectedItem,
      options,
      className=''
    } = this.props;
    let toggle;
    if (!!selectedItem) {
      toggle = <div>
        <span>{selectedItem.description}</span>
        <MdArrowDropDown className="dropdown-arrow" />
      </div>;
    } else {
      toggle = 'No options available';
    }

    return (
      <div className={`${styles.dropdownField} dropdown ${className}`}>
        {!!title && <label>{title}</label>}
        <DropdownMenu dropdownNode={toggle} closeAfterClick>
          {options.map(item => <DropdownMenuItem key={item.value} menuItem={item} />)}
        </DropdownMenu>
      </div>
    );
  }
}

export const DropdownField = DropdownFieldComponent;
